<!--
 * @Author: your name
 * @Date: 2020-06-24 15:00:44
 * @LastEditTime: 2020-07-25 09:39:43
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \Parts_APP\src\components\bottom\index.vue
-->
<template>
    <div class="bottom">
        <van-tabbar v-model="active">
            <van-tabbar-item @click='shouye' :key="1" name="首页" :class="{active: $route.path=='/'}" icon="wap-home" to="/" class="bottom-text">首页</van-tabbar-item>
            <van-tabbar-item @click='wode' :key='2' name="我的" :class="{active: $route.path=='/myhome'}" icon="manager" to="/myhome"  class="bottom-text">我的</van-tabbar-item>
        </van-tabbar>
        <!-- <div class="item" :class="{active: $route.path=='/'}" @click="clickItem('/')">
            <icon name="wap-home" color="#1989fa" size="23" />
            <p>首页</p>
        </div>
        <div class="item" :class="{active: $route.path=='/myhome'}" @click="clickItem('/myhome')">
            <icon name="manager" size="23" />
            <p>我的</p>
        </div> -->
    </div>
</template>

<script>
import { Icon } from 'vant'
export default {
    name: 'Bottom',
    components: {
        Icon
    },
    data() {
        return {
          active:''
        }
    },
    methods: {
      shouye(){
        this.active='首页'
      },
      wode(){
        this.active='我的'
      }
    }

}
</script>

<style scoped>
  .bottom{
    position: fixed;
    bottom:0px;
    border-top:1px solid #d2d2d2;
    background-color: #f2f2f2;
    width: 100%;
    height:90px;
  }
  .bottom-text{
    font-size: 0.3rem;
  }
  .item{
    margin:5px 20%;
    float:left;
  }
  .item p{
    margin:0;
    font-size: 15px;
  }
  .active{
    color:#1989ff;
  }
  .bottom .van-tabbar{
    height:1.2rem;
    background: transparent;
  }
</style>

